/*
 * Pagination Messages
 *
 * This contains all the text for the Pagination component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  previous: {
    id: 'app.components.Pagination.previous',
    defaultMessage: 'Previous',
  },
  next: {
    id: 'app.components.Pagination.next',
    defaultMessage: 'Next',
  },
  numbers: {
    id: 'app.components.Pagination.numbers',
    defaultMessage: 'Page {page}/{length}',
  },
});
